export const siteInfo = {
  brand: "1每日吃瓜",
  fullName: "1每日吃瓜 · 娱乐热点聚合",
  slogan: "每日一站，吃遍全网大瓜",
  description:
    "聚焦每日吃瓜热门事件与大瓜汇总的中文内容门户，提供本周瓜单、焦点事件脉络梳理与热门事件深度盘点。",
  email: "hi@1meirichigua.com",
  workingHours: "每日 09:00 - 24:00 更新",
  nav: [
    { label: "首页", path: "/" },
    { label: "热门事件", path: "/events" },
    { label: "本周瓜单", path: "/roundup" },
    { label: "关于我们", path: "/about" },
  ],
};

export const stats = [
  { value: "365+", label: "每日持续更新" },
  { value: "1200+", label: "已梳理事件脉络" },
  { value: "8.6万", label: "瓜单订阅读者" },
  { value: "6 大", label: "内容分类方向" },
];

export const principles = [
  {
    icon: "ri-shield-check-line",
    title: "只梳理公开线索",
    desc: "以公开渠道已形成讨论的内容为素材，按时间线梳理脉络，不臆测、不放大未确认信息。",
  },
  {
    icon: "ri-scales-3-line",
    title: "克制而平衡",
    desc: "描述事件时尽量还原多方信息，避免单一视角的引导，把判断空间留给读者自己。",
  },
  {
    icon: "ri-time-line",
    title: "重视时间脉络",
    desc: "比起零散的热搜片段，我们更愿意花时间把事件的前因后果串成一条清晰的线索。",
  },
  {
    icon: "ri-heart-3-line",
    title: "尊重每一位当事人",
    desc: "讨论内容与作品，不针对个人进行人身评价，这是内容生产最基本的边界。",
  },
];

export const testimonials = [
  {
    name: "林小满",
    role: "通勤党 · 3 年读者",
    text: "以前刷热搜总是一头雾水，现在习惯了先来这儿看脉络梳理，几分钟就能把前因后果搞清楚，特别省时间。",
  },
  {
    name: "阿澈",
    role: "剧集爱好者",
    text: "本周瓜单是我每周日晚上的固定节目，榜单排序和热度说明都挺有参考价值，不会为了吸引眼球乱写。",
  },
  {
    name: "木木",
    role: "内容从业者",
    text: "最欣赏的是克制。同一个事件它会把多方信息都写上，不站队也不煽动情绪，这种态度在资讯站里挺难得。",
  },
  {
    name: "周野",
    role: "大学生",
    text: "排版看着很舒服，分类也清晰。考试周想快速补课这几天的热点，直接看热门事件列表就够了。",
  },
];

export const milestones = [
  { year: "2021", text: "以「每日一站」为初衷上线，从一张人工排布的瓜单开始" },
  { year: "2023", text: "推出事件脉络梳理栏目，尝试用时间线还原讨论走向" },
  { year: "2024", text: "上线本周瓜单订阅，读者规模突破五万" },
  { year: "2026", text: "内容分类细化为六大方向，坚持克制而平衡的表达" },
];